// extracted by mini-css-extract-plugin
export default {"item":"OverlayListItem_item__sjGJX","selected":"OverlayListItem_selected__qPPxX","icon":"OverlayListItem_icon__XakvE","title":"OverlayListItem_title__1D8uB"};